// extracted by mini-css-extract-plugin
export default {"base":"vp_tOv35","head":"vp_u_ox1","updated":"vp_m7XKa","layout":"vp_AXDoR","toc":"vp__chHR","tocLabel":"vp_wKtSt","other":"vp_f9dPo","body":"vp_m_pLv","intro":"vp_eAHrU"};